import React from 'react';
import PropTypes from 'prop-types';
import { Badge, UncontrolledTooltip } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import HelpCircleOutlineIcon from 'mdi-react/HelpCircleOutlineIcon';

const SidebarLink = ({
  title, icon, newLink, route, onClick, isQuestionIcon, tooltipText, idTooltip
}) => (
  <NavLink
    to={route}
    onClick={onClick}
    className={({isActive}) => isActive ? 'sidebar__link-active' : ''}
  >
    <li className="sidebar__link">
      {icon ? <span className={`sidebar__link-icon lnr lnr-${icon}`} /> : ''}
      <p className="sidebar__link-title">
        {title}
        {isQuestionIcon ? (
          <>
            <HelpCircleOutlineIcon size={"14px"} className={"ml-1"} id={idTooltip} />
            <UncontrolledTooltip placement="top" target={idTooltip}>
              {tooltipText}
            </UncontrolledTooltip>
          </>
        ) : null}
        {newLink ? <Badge className='sidebar__link-badge'><span>New</span></Badge> : ''}
      </p>
    </li>
  </NavLink>
);

SidebarLink.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  newLink: PropTypes.bool,
  route: PropTypes.string,
  onClick: PropTypes.func,
};

SidebarLink.defaultProps = {
  icon: '',
  newLink: false,
  route: '/',
  onClick: () => {},
};

export default SidebarLink;
